import { Card, Col, CardBody } from "reactstrap";
import { SimpleModal } from "./SimpleModal";
import ScrollingModal from "./ScrollingModal";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicModal } from "../../../../Constant";
import { BASIC_DATA } from "../../../../Data/UiKit/Modal";
import { ToolTipAndPopover } from "./ToolTipAndPopover";
import OpenModalBoho from "./OpenModalBoho";

const BasicModalCart = () => {
  return (
      <Col lg="6">
        <Card>
          <CommonCardHeader title={BasicModal} span={BASIC_DATA} />
          <CardBody className="badge-spacing">
            <SimpleModal />
            <ScrollingModal />
            <ToolTipAndPopover />
            <OpenModalBoho />
          </CardBody>
        </Card>
      </Col>
  );
};

export default BasicModalCart;
